import OrnamentHeart from '../../../lib/icons/OrnamentHeart';
import OrnamentStethoscope from '../../../lib/icons/OrnamentStethoscope';
import styles from './LearningDetailsOrnaments.module.scss';
import { classes, ClassType } from '../../../lib/utils/cssUtils';

type LearningDetailsOrnamentsProps = {
  stethoscopeClassName?: ClassType;
  heartClassName?: ClassType;
};

const LearningDetailsOrnaments = ({ stethoscopeClassName, heartClassName }: LearningDetailsOrnamentsProps) => {
  return (
    <>
      <OrnamentHeart className={classes(styles.heart, heartClassName)} aria-hidden="true" />
      <div aria-hidden="true" className={classes(styles.stethoscopeContainer, stethoscopeClassName)}>
        <OrnamentStethoscope className={styles.stethoscope} />
      </div>
    </>
  );
};

export default LearningDetailsOrnaments;
